module.exports = __webpack_public_path__ + "images/psp/College/unit-10x15.svg";